module.exports = __webpack_public_path__ + "static/img/BSMI_01.60520506.jpg";